/**
 * Support for localStorage and sessionStorage under DAL
 */
import update from 'react-addons-update';
import { addReducer, addStorePart } from './store';


/**
 * Constants
 */
export const storageConst = {
    STORE_PART: 'omfe-core-data:storage',

    SAVE_LOCAL_ITEM: 'OMFE_CORE_DATA_WEBSTORAGE_SAVE_LOCAL_ITEM',
    SAVE_SESSION_ITEM: 'OMFE_CORE_DATA_WEBSTORAGE_SAVE_SESSION_ITEM',
    DELETE_ITEM: 'OMFE_CORE_DATA_WEBSTORAGE_DELETE_ITEM',

    INIT: 'OFME_CORE_DATA_WEBSTORAGE_INIT',

    INVALID_KEY_TYPE: 'Invalid key type. For performance reasons stored item keys may only be strings.',
    INVALID_VALUE_TYPE: 'Invalid value type. For performance reasons stored items may only be strings. ',
};

/**
 * Default State
 * - retrieves existing objects automatically
 * - puts them in STORE_PART
 * - localStorage will overwrite sessionStorage
 */
function getItems(storage) {
    if (typeof window !== 'object' || window === null || !window[storage] || !window[storage].getItem) {
        return {};
    }
    const engine = window[storage];
    const data = {};
    Object.keys(engine).forEach((key) => { data[key] = engine.getItem(key); });
    return data;
}

addStorePart(storageConst.STORE_PART,
    Object.assign({}, getItems('sessionStorage'), getItems('localStorage')));

/**
 * Reducers
 */
// save localStorage and sessionStorage items
addReducer(storageConst.STORE_PART, storageConst.SAVE_LOCAL_ITEM, (state = {}, action) =>
    update(state, { $merge: { [action.key]: action.value } }));

addReducer(storageConst.STORE_PART, storageConst.SAVE_SESSION_ITEM, (state = {}, action) =>
    update(state, { $merge: { [action.key]: action.value } }));

// delete any item
addReducer(storageConst.STORE_PART, storageConst.DELETE_ITEM, (state = {}, action) => {
    const newState = Object.assign({}, state); // shallow copy
    delete newState[action.key]; // delete item
    return newState; // return
});


/**
 * saveLocalItem - Saves an item to localStorage
 *
 * @param  {string}     key         key to use
 * @param  {string}     value       value to store
 * @return {object}                 action
 */
export function saveLocalItem(key, value) {
    if (typeof key !== 'string') {
        throw new Error(storageConst.INVALID_KEY_TYPE);
    }

    if (typeof value !== 'string') {
        throw new Error(storageConst.INVALID_VALUE_TYPE);
    }

    if (typeof window !== 'undefined' && window.localStorage && window.localStorage.setItem) {
        window.localStorage.setItem(key, value);
    }
    return { type: storageConst.SAVE_LOCAL_ITEM, key, value };
}

/**
 * saveSessionItem - Saves an item to sessionStorage
 *
 * @param  {string}     key         key to use
 * @param  {string}     value       value to store
 * @return {object}                 action
 */
export function saveSessionItem(key, value) {
    if (typeof key !== 'string') {
        throw new Error(storageConst.INVALID_KEY_TYPE);
    }

    if (typeof value !== 'string') {
        throw new Error(storageConst.INVALID_VALUE_TYPE);
    }

    if (typeof window !== 'undefined' && window.sessionStorage && window.sessionStorage.setItem) {
        window.sessionStorage.setItem(key, value);
    }
    return { type: storageConst.SAVE_SESSION_ITEM, key, value };
}

/**
 * deleteItem - Removes an item from both localStorage and sessionStorage
 *
 * @param  {string}     key     item key to remove
 * @return {object}             action
 */
export function removeItem(key) {
    if (typeof key !== 'string') {
        throw new Error(storageConst.INVALID_KEY_TYPE);
    }

    if (typeof window !== 'undefined' && window.localStorage && window.localStorage.removeItem) {
        window.localStorage.removeItem(key);
    }
    if (typeof window !== 'undefined' && window.sessionStorage && window.sessionStorage.removeItem) {
        window.sessionStorage.removeItem(key);
    }
    return { type: storageConst.DELETE_ITEM, key };
}



// WEBPACK FOOTER //
// ./src/OMFECore/storage.js